module.exports = __webpack_public_path__ + "static/media/imgsucc.66ee59eb.svg";